import { TABLE_INPUT_TYPES } from '../../common/table/constants';

export default [
  {
    Header: 'Account ID',
    id: 'accountId',
    accessor: 'accountId',
    minWidth: 170,
    uneditable: true,
  },
  {
    Header: 'Tungsten Account Internal Identifier',
    id: 'gcAccountId',
    accessor: 'gcAccountId',
    minWidth: 150,
    uneditable: true,
    hideFilter: true,
  },
  {
    Header: 'Member ID',
    id: 'memberId',
    accessor: 'memberId',
    minWidth: 150,
    uneditable: true,
  },
  {
    Header: 'Firm Code',
    id: 'firmCode',
    accessor: 'firmCode',
    minWidth: 170,
    uneditable: true,
  },
  {
    Header: 'Account Code',
    id: 'accountCode',
    accessor: 'accountCode',
    minWidth: 180,
    uneditable: true,
  },
  {
    Header: 'Subaccount Code',
    id: 'subAccountCode',
    accessor: 'subAccountCode',
    minWidth: 180,
    uneditable: true,
  },
  {
    Header: 'Name',
    id: 'name',
    accessor: 'name',
    minWidth: 160,
    uneditable: true,
  },
  {
    Header: 'Label',
    id: 'label',
    accessor: 'label',
    minWidth: 180,
    uneditable: true,
    hideFilter: true,
  },
  {
    Header: 'Account Type',
    id: 'accountType',
    accessor: 'accountType',
    minWidth: 170,
    uneditable: true,
    hideFilter: true,
  },
  {
    Header: 'Member Label',
    id: 'memberLabel',
    accessor: 'memberLabel',
    minWidth: 180,
    uneditable: true,
    hideFilter: true,
  },
  {
    Header: 'Discretionary Add On',
    id: 'discretionaryAddOn',
    accessor: 'discretionaryAddOn',
    editInputType: TABLE_INPUT_TYPES.NUMBER,
    min: 0,
    minWidth: 180,
    hideFilter: true,
  },
];
